// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"497ad812","160":"f6c00ffc","208":"6ac6da5e","293":"fc07efb4","453":"0a7f0965","516":"c6f0c29d","519":"b55369ff","917":"9b514980","946":"2811fb94"}[chunkId] + ".chunk.js";
};